module.exports = __webpack_public_path__ + "media/images/tone_beep-4e2c7f8e17a0adf3e6e941b0c8467443.mp3";